export class RequestConsultaPartes {
    partId: number;
	categoria : string[];
	lineId : number[];
	modelo: string;
	precioMin: number;
	precioMax: number;
	keyWords: string;
	first: number;
	pageSize: number;
    order: string;
    
    constructor(){
        
    }
}
